module.exports = __webpack_public_path__ + "static/img/t5-3.da1a6c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/t5-3.png
// module id = FLbs
// module chunks = 1